import { SomethingWentWrong } from "~/common/assets";
import { DescriptiveErrorLayout } from "~/common/components";
import { LOGO_POSITION } from "~/common/constants";
import { BlueWavesBackground } from "../assets";

export const ConsultationInactiveScreen = () => (
  <DescriptiveErrorLayout
    backgroundUrl={BlueWavesBackground}
    logoPosition={LOGO_POSITION.top}
    description="This consultation request link is no longer active."
  >
    <img src={SomethingWentWrong} alt="consultation inactive" />
  </DescriptiveErrorLayout>
);
